import React from 'react';
import { stats } from '../data/content';
export function StatsBar() {
  return <section className="w-full border-y border-ink/10 bg-paper-deep" data-id="element-206" data-mp="1tai2pb8gatrc">
      <div className="mx-auto max-w-6xl px-8 py-14 sm:px-14 lg:flex lg:items-center lg:gap-14" data-id="element-207" data-mp="1tb9sg5fd9x9p">
        <h2 className="shrink-0 font-hand text-3xl leading-none text-pen lg:w-40" data-id="element-208" data-mp="1o9keagwul3he">
          Le pack en chiffres
        </h2>
        <dl className="mt-8 grid grid-cols-2 gap-x-6 gap-y-10 lg:mt-0 lg:flex-1 lg:grid-cols-4" data-id="element-209" data-mp="1ed7indhqsfk0">
          {stats.map(stat => <div key={stat.label} className="flex flex-col-reverse border-l border-ink/15 pl-5" data-id="element-210" data-mp="19lzaeks5f08f">
              <dt className="mt-3 text-sm leading-snug text-ink/70" data-id="element-211" data-mp="15ke1tbmnd841">{stat.label}</dt>
              <dd className="font-display text-6xl leading-none tracking-tight text-ink sm:text-7xl" data-id="element-212" data-mp="10lt2rfj4suh6">
                {stat.value}
              </dd>
            </div>)}
        </dl>
      </div>
    </section>;
}